<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Keywords Management</h3>
      </div>
      <div class="col-2 ml-auto">
        <label class="mb-0" for=""><u>Items Per Page</u></label>
        <select (change)="itemsPerPageChange($event.target.value)" class="form-control">
          <option *ngFor="let ipp of pagingList">{{ipp}}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for="gotoShortCode"><u>Goto ShortCode</u></label>
        <ng-select [items]="allShortCodes" bindLabel="scView" placeholder="Goto ShortCode" [(ngModel)]="targetShortCode" class="form-control" (ngModelChange)="gotoTargetShortCode($event)">
        </ng-select>
      </div>
      <div class="col">
        <label for=""><u>Filter by Source</u></label>
        <select [(ngModel)]="filterable.source" class="form-control" placeholder="Source" (ngModelChange)="changeFilSource($event)">
          <option value=null selected>All</option>
          <option *ngFor="let source of filterSourceList" [ngValue]="source">{{source.name}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><u>Filter by Country</u></label>
        <select [(ngModel)]="filterable.country" class="form-control" placeholder="Country" (ngModelChange)="changeFilCountry($event)">
          <option value=null selected>All</option>
          <option *ngFor="let country of filterCountryList | keyvalue" [ngValue]="country.value">{{country.key}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><u>Filter by Operator</u></label>
        <select [(ngModel)]="filterable.operator" class="form-control" placeholder="Operator" (ngModelChange)="changeFilOperator($event)">
          <option value=null selected>- select operator-</option>
          <option *ngFor="let op of filterOperatorList | keyvalue" [ngValue]="op.key">{{op.key}}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for=""><u>Filter by Short Code</u></label>
        <!-- <input type="text" formControlName="shortCode" class="form-control" placeholder="enter short code" /> -->
        <ng-select [items]="filterShortCodeList" (clear)="onClear()" placeholder="Select short code" [(ngModel)]="filterable.shortCode" class="form-control" (ngModelChange)="changeFilShortCode($event)">
        </ng-select>
      </div>
      <div class="col">
        <label for=""><u>Filter by Keyword</u></label>
        <select [(ngModel)]="filterable.keyword" class="form-control" placeholder="Keyword">
          <option value=null selected>-select keyword-</option>
          <option *ngFor="let kw of filterKeywordList" [ngValue]="kw">{{kw.keyword}}</option>
        </select>
      </div>
      <!-- <div class="col">
        <label for=""><u>Filter by Keyword Type</u></label>
        <select [(ngModel)]="filterable.type" class="form-control" placeholder="Type">
          <option value="" selected>All</option>
          <option *ngFor="let type of typeList | keyvalue" [value]="type.key">{{type.value}}</option>
        </select>
      </div> -->
      <div class="col">
        <label for=""><u>Filter by Client</u></label>
        <select [(ngModel)]="filterable.managerName" class="form-control" placeholder="Client Name">
          <option value="" selected>All</option>
          <option *ngFor="let client of clientList" [value]="client.username">{{client.username}}</option>
        </select>
      </div>
      <div class="col ml-auto text-right  align-self-end">
        <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
        <button class="btn btn-danger btn-sm mr-2" (click)="clear()">Clear</button>
        <button class="btn btn-success btn-sm mr-2" (click)="export()" *ngIf="!exporting">Export</button>
        <button class="btn btn-success btn-sm mr-2 d-none" id="download" (click)="openModal(viewDownloadUrl)">Open</button>
        <button class="btn btn-success btn-sm mr-2" *ngIf="exporting" disabled>Exporting</button>
        <button class="btn btn-outline-success btn-sm text-dark font-weight-bold" (click)="openModal(newKeywordModal)" *ngIf="currentUser.roleName == 'ADMIN'">+ Keyword </button>
  </div>
    </div>
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-2 align-self-center">
    Total Results: {{totalItems}}
  </div>
  <!-- <div class="col-2 align-self-center" *ngIf="maxPageSize > 1">
    <label for=""><u>Go to page </u> <span class="small">(Max: {{maxPageSize}})</span></label>
    <input type="number" class="form-control form-control-sm" placeholder="Page" [(ngModel)]="goToPage" max="{{maxPageSize}}">
  </div>
  <div class="col-2 align-self-center" *ngIf="maxPageSize > 1">
    <button (click)="setPage(goToPage)" class="btn btn-sm btn-outline-primary">Go</button>
  </div> -->

</div>
<!-- <div class="table-responsive"> -->
<table id="keywordList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
  <thead>
    <tr>
      <th>ShortCode</th>
      <th>Keyword</th>
      <th>Operator</th>
      <th>Source</th>
      <th>Price</th>
      <th>Client</th>
      <th>Share</th>
      <th>Spider Account</th>
      <th>Postback Min</th>
      <th>Postback Rate(%)</th>
      <th>Postback Cap</th>
      <th>Postback URL</th>
      <th>Operate</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngIf="loading">
      <td colspan="16">
        <div class="loader">Loading...</div>
      </td>
    </tr>
    <tr *ngIf="emptyResult">
      <td colspan="16">
        <div class="alert alert-warning">Empty Result...</div>
      </td>
    </tr>
    <tr *ngFor="let keyword of keywords; index as i;">
      <td>{{keyword.shortCode}}</td>
      <td>{{keyword.keyword}}</td>
      <td>{{keyword.operator}}</td>
      <td>{{keyword.sourceView}}</td>
      <td align="right">{{keyword.price}}{{keyword.currency}}</td>
      <td><span *ngIf="!keyword.managerName">-</span>
        <span *ngIf="keyword.managerName">{{keyword.managerName}}</span>
      </td>
      <td>
          <span *ngIf="!keyword.share">-</span>
          <span *ngIf="keyword.share">{{keyword.share}}</span>
        </td>
      <td>
        <span *ngIf="!keyword.spiderAccountName">-</span>
        <span *ngIf="keyword.spiderAccountName">{{keyword.spiderAccountName}}</span>
      </td>
      <td class="text-left">
        MO: {{keyword.moMin}} <br>
        DN: {{keyword.dnMin}} <br>
        CNV: {{keyword.cnvMin}}
      </td>
      <td class="text-left">
        MO: {{keyword.moPostBackRate}} <br>
        DN: {{keyword.dnPostBackRate}} <br>
        CNV: {{keyword.cnvPostBackRate}}
      </td>
      <td class="text-left">
        MO: {{keyword.moCap}} <br>
        DN: {{keyword.dnCap}} <br>
        CNV: {{keyword.cnvCap}}
      </td>
      <td class="text-left">
        MO: <a href="{{keyword.moNotifyUrl}}" target="_blank"> {{keyword.moNotifyUrl}}</a> <br>
        DN: <a href="{{keyword.dnNotifyUrl}}" target="_blank"> {{keyword.dnNotifyUrl}}</a> <br>
        CNV: <a href="{{keyword.cnvUrl}}" target="_blank">{{keyword.cnvUrl}}</a> <br>
      </td>
      <!-- <td>
          <a [routerLink]="['/dashboard/mt-detail', emp.id]">
            <span class="badge">view </span>
          </a>
        </td> -->
      <td>
        <!-- <button type="button" class="btn btn-primary py-1 px-2"  placement="top" ngbTooltip="Tooltip on top">

          </button> -->
        <a type="button" class="btn btn-sm btn-primary mr-2 mt-2" placement="top" ngbTooltip="View & Edit" [routerLink]="['/dashboard/keyword-detail', keyword.id]" *ngIf="currentUser.roleName == 'ADMIN'">
          <i class="fas fa-pen"></i>
        </a>
        <button type="button" class="btn btn-sm btn-danger mr-2 mt-2" placement="top" ngbTooltip="Delete" (click)="deleteKeyword(keyword)"  *ngIf="currentUser.roleName == 'ADMIN'">
          <i class="fas fa-trash"></i>
        </button>

        <a class="btn btn-sm btn-primary mt-2" [routerLink]="['/dashboard/keyword', keyword.id, 'affiliate']" *ngIf="keyword.affiliateEnabled">
          <span class="badge">Affiliate</span>
        </a>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td colspan="16" *ngIf="!loading && !emptyResult">
        <pagination [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [(ngModel)]="currentPage" [maxSize]="maxSize" class="pagination-md mb-0 justify-content-center" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
          lastText="&raquo;" [boundaryLinks]="true" [rotate]="false" (numPages)="numPages = $event" (pageChanged)="pageChanged($event)"></pagination>
        <!-- <button (click)="setPage(2)">GO TO PAGE</button> -->
      </td>
    </tr>
  </tfoot>
</table>
<!-- </div> -->

<ng-template #newKeywordModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="newKeywordLabel">New Keyword</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" id="newKeyword-modal-body">
    <form [formGroup]="newKeywordForm" (ngSubmit)="onSubmit()">
      <small><i class="text-danger">* indicates mandatory field</i></small>
      <div class="form-group row p-2">

        <div class="col-sm-6">
          <label for="source" class="col-form-label"><span class="text-danger">* </span>Source: </label>
          <select formControlName="source" class="form-control" placeholder="Source" (ngModelChange)="changeAddSource($event)" >
            <option value="">-select source-</option>
            <option *ngFor="let source of sourceList | keyvalue" [value]="source.key">{{source.value}}</option>
          </select>
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.source.errors">
              Source cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="country" class="col-form-label"><span class="text-danger">* </span>Country: </label>
          <select class="form-control" placeholder="Select" (ngModelChange)="changeCountry($event)" formControlName="country">
            <option value="">-select country-</option>
            <option *ngFor="let country of countryList" [ngValue]="country">{{country.name}}</option>
          </select>
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.country.errors">
              Country cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="operator" class="col-form-label"><span class="text-danger">* </span>Operator: </label>
          <select class="form-control" placeholder="Select" formControlName="operator">
            <option value="">-select operator-</option>
            <option *ngFor="let operator of operatorList" [value]="operator">{{operator}}</option>
          </select>
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.operator.errors">
              Operator cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="shortCode" class="col-form-label"><span class="text-danger">* </span>Short Code: </label>
          <input type="text" class="form-control" formControlName="shortCode" placeholder="Short Code">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.shortCode.errors">
              Short Code cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="keyword" class="col-form-label"><span class="text-danger">* </span>Keyword: </label>
          <input type="text" class="form-control" formControlName="keyword" placeholder="Keyword">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.keyword.errors">
              Keyword cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="price" class="col-form-label"><span class="text-danger">* </span>Price: </label>
          <input type="number" class="form-control" formControlName="price" placeholder="price">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.price.errors">
              Price cannot be blank.
            </div>
          </div>
        </div>
        <!-- <div class="col-sm-6">
          <label for="type" class="col-form-label"><span class="text-danger">* </span>Type: </label>
          <select class="form-control" placeholder="Select" formControlName="type">
            <option value="">-select type-</option>
            <option *ngFor="let type of typeList | keyvalue" [value]="type.key">{{type.value}}</option>
          </select>
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.type.errors">
              Type cannot be blank.
            </div>
          </div>
        </div> -->

        <div class="col-sm-6">
          <label for="category" class="col-form-label"><span class="text-danger">* </span>Category: </label>
          <select class="form-control" placeholder="Select" formControlName="category">
            <option *ngFor="let categoryEle of categoryList" [value]="categoryEle.code">{{categoryEle.name}}</option>
          </select>
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.category.errors">
              Category cannot be blank.
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <label for="interval" class="col-form-label"><span class="text-danger">* </span>Interval: </label>
          <select class="form-control" placeholder="Select" formControlName="interval">
            <option value="">-select interval-</option>
            <option *ngFor="let interval of intervalList | keyvalue" [value]="interval.key">{{interval.value}}</option>
          </select>
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.interval.errors">
              Interval cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
            <label for="schedules" class="col-form-label"><span class="text-danger">* </span>Schedules:
              &nbsp;<i class="fas fa-question-circle" placement="top"></i> &nbsp;<a target="_blank" [routerLink]="['/dashboard/support/schedule']">View usage</a>
            </label>

            <input type="text" class="form-control" formControlName="schedules" placeholder="split by ,">
            <div class="text-danger small" *ngIf="showError">
              <div *ngIf="f.schedules.errors">
                  Schedules cannot be blank.
              </div>
            </div>
        </div>
        <div class="col-sm-6">
          <label for="premiumService" class="col-form-label">Premium Service: </label>
          <input type="text" class="form-control" formControlName="premiumService" placeholder="Premium Service ID">
        </div>
        <div class="col-sm-6">
          <label for="moNotifyUrl" class="col-form-label">MO Postback Url: </label>
          <input type="text" class="form-control" formControlName="moNotifyUrl" placeholder="MO postback url">
        </div>
        <div class="col-sm-6">
          <label for="cnvUrl" class="col-form-label">Conversion Url: <i class="fas fa-info-circle" placement="top" ngbTooltip="Macro of clickId: {click_id}"></i> </label>
          <input type="text" class="form-control" formControlName="cnvUrl" placeholder="Conversion postback url">
        </div>
        <div class="col-sm-6">
          <label for="dnNotifyUrl" class="col-form-label">DN Postback Url: </label>
          <input type="text" class="form-control" formControlName="dnNotifyUrl" placeholder="DN postback url">
        </div>
        <div class="col-sm-6">
          <label for="moMin" class="col-form-label"><span class="text-danger">* </span>MO Postback Min: <i class="fas fa-info-circle" placement="top" ngbTooltip="Less than or equal to 0 means no limit"></i></label>
          <input type="number" class="form-control" formControlName="moMin" placeholder="0">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.moMin.errors">
              Mo Min cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="dnMin" class="col-form-label"><span class="text-danger">* </span>DN Postback Min: <i class="fas fa-info-circle" placement="top" ngbTooltip="Less than or equal to 0 means no limit"></i></label>
          <input type="number" class="form-control" formControlName="dnMin" placeholder="0">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.dnMin.errors">
              Dn Min cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="cnvMin" class="col-form-label"><span class="text-danger">* </span>Convertion Postback Min: <i class="fas fa-info-circle" placement="top" ngbTooltip="Less than or equal to 0 means no limit"></i></label>
          <input type="number" class="form-control" formControlName="cnvMin" placeholder="0">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.cnvMin.errors">
              Cnv Min cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="moCap" class="col-form-label"><span class="text-danger">* </span>MO Postback Cap: <i class="fas fa-info-circle" placement="top" ngbTooltip="Less than or equal to 0 means no limit"></i></label>
          <input type="number" class="form-control" formControlName="moCap" placeholder="0">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.moCap.errors">
              Mo Cap cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="dnCap" class="col-form-label"><span class="text-danger">* </span>DN Postback Cap: <i class="fas fa-info-circle" placement="top" ngbTooltip="Less than or equal to 0 means no limit"></i></label>
          <input type="number" class="form-control" formControlName="dnCap" placeholder="0">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.dnCap.errors">
              Dn Cap cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="cnvCap" class="col-form-label"><span class="text-danger">* </span>Convertion Postback Cap: <i class="fas fa-info-circle" placement="top" ngbTooltip="Less than or equal to 0 means no limit"></i></label>
          <input type="number" class="form-control" formControlName="cnvCap" placeholder="0">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.cnvCap.errors">
              Cnv Cap cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="moPostBackRate" class="col-form-label"><span class="text-danger">* </span>MO Postback Rate: <i class="fas fa-info-circle" placement="top" ngbTooltip="0-100"></i></label>
          <input type="number" class="form-control" formControlName="moPostBackRate" placeholder="100" min="0" max="100">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.moPostBackRate.errors">
              Mo post-back rate cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="dnPostBackRate" class="col-form-label"><span class="text-danger">* </span>DN Postback Rate: <i class="fas fa-info-circle" placement="top" ngbTooltip="0-100"></i></label>
          <input type="number" class="form-control" formControlName="dnPostBackRate" placeholder="100" min="0" max="100">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.dnPostBackRate.errors">
              Dn post-back rate cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="cnvPostBackRate" class="col-form-label"><span class="text-danger">* </span>Convertion Postback Rate: <i class="fas fa-info-circle" placement="top" ngbTooltip="0-100"></i></label>
          <input type="number" class="form-control" formControlName="cnvPostBackRate" placeholder="100" min="0" max="100">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.cnvPostBackRate.errors">
              Cnv post-back rate cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="affiliateEnabled" class="col-form-label">Affiliate Enabled</label>
          <select class="form-control" placeholder="Select" formControlName="affiliateEnabled">
            <option value="false">Disabled</option>
            <option value="true">Enabled</option>
          </select>
        </div>
        <div class="col-sm-6">
          <label for="affiliateClickEnabled" class="col-form-label">Affiliate From ClickId</label>
          <select class="form-control" placeholder="Select" formControlName="affiliateClickEnabled">
            <option value="false">NO</option>
            <option value="true">YES</option>
          </select>
        </div>
        <div class="col-sm-6">
          <label for="managerId" class="col-form-label">Spider Account</label>
          <select class="form-control" placeholder="Select" formControlName="spiderAccountId">
            <option value="">-select account-</option>
            <option *ngFor="let account of spiderAccountList" [value]="account.id">{{account.name}}</option>
          </select>
        </div>
        <div class="col-sm-6">
          <label for="share" class="col-form-label">Share: </label>
          <input type="text" class="form-control" formControlName="share" placeholder="share label">
        </div>
        <div class="col-sm-6">
          <label for="managerId" class="col-form-label">Client</label>
          <select class="form-control" placeholder="Select" formControlName="managerId">
            <option value="">-select client-</option>
            <option *ngFor="let client of clientList" [value]="client.id">{{client.username}}</option>
          </select>
        </div>
        <div class="col-sm-6">
          <label for="reminderPeriod" class="col-form-label">Reminder Period</label>
          <select class="form-control" placeholder="Select" formControlName="reminderPeriod">
            <option value="">-select period-</option>
            <option *ngFor="let period of reminderPeriodList" [value]="period.code">{{period.name}}</option>
          </select>
        </div>
        <div class="col-sm-6">
          <label for="revenueShareRatio" class="col-form-label">Revenue Share Ratio: </label>
          <input type="number" min="0" class="form-control" formControlName="revenueShareRatio" placeholder="Revenue Share Ratio">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
        <button type="submit" class="btn btn-primary" *ngIf="!processing">Add Keyword</button>
        <button type="submit" class="btn btn-primary" *ngIf="processing" disabled>Processing..</button>
      </div>
    </form>
  </div>


</ng-template>

<ng-template #viewDownloadUrl let-modal>
    <div class="modal-header">
      <h5 class="modal-title" id="downloadUrl-header">Download URL</h5>
      <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <div class="form-group row">
        <div class="col-12">
          Click to download:
          <a href={{downloadUrl}} target="_blank">
            {{downloadUrl}}
          </a>
        </div>
      </div>
    </div>
  </ng-template>
